import { getActivityDetail, commitInfo, modifyInfo, getAdDetail } from "@/server/interfaces"
import { USER_INFO_KEY_MAP } from "@/dictionary"

export default {
  namespaced: true,
  state: {
    activityCategorys: [],
    adDetail: {},
    worksTypes: [],
    commitSuccess: false,
    defaultOpt: {}
  },
  getters: {
    activityCategorys: state => state.activityCategorys,
    commitSuccess: state => state.commitSuccess,
    adDetail: state => state.adDetail,
    worksTypes: state => state.worksTypes,
    defaultOpt: state => state.defaultOpt
  },
  mutations: {
    updataCommitStatus(state, status) {
      state.commitSuccess = status
    },
    setActivityCategorys(state, dataList) {
      state.activityCategorys = dataList
    },
    setAdDetail(state, data) {
      state.adDetail = data
    },
    setWorksTypes(state, dataList) {
      state.worksTypes = dataList
    },
    setDefaultOpt(state, defaultOpt) {
      state.defaultOpt = defaultOpt
    }
  },
  actions: {
    async commit({ commit, rootState }, option) {
      const activityId = rootState.activityInfo.activityId
      const userUuid = rootState.userInfo.userInfo.userUuid
      option.params.userUuid = userUuid
      option.params.activityId = activityId
      const IS_COMMIT_SUCCESS = await commitInfo(option)
      commit("updataCommitStatus", IS_COMMIT_SUCCESS)
    },
    async modify({ commit, rootState }, option) {
      const activityId = rootState.activityInfo.activityId
      const userUuid = rootState.userInfo.userInfo.userUuid
      option.params.userUuid = userUuid
      option.params.activityId = activityId
      const IS_COMMIT_SUCCESS = await modifyInfo(option)
      commit("updataCommitStatus", IS_COMMIT_SUCCESS)
    },
    async getActivityDataList({ commit, rootState }, option) {
      const activityId = rootState.activityInfo.activityId
      option.params.id = activityId
      const { activityCategorys, worksTypes } = await getActivityDetail(option)
      commit("setActivityCategorys", activityCategorys)
      commit("setWorksTypes", worksTypes)
    },
    async getAdDetailInfo({ commit, rootState }, option) {
      const activityId = rootState.activityInfo.activityId
      option.params.activityId = activityId
      const { contributePageTop } = await getAdDetail(option)
      commit("setAdDetail", contributePageTop)
    },
    initDefaultOpt({ commit, rootState }) {
      const contributeDefaultOptions = rootState.activityInfo.contributeDefaultOptions
      const userInfo = rootState.userInfo.userInfo
      const defaultOpt = {}
      contributeDefaultOptions.forEach(option => {
        const key = USER_INFO_KEY_MAP[option]
        const isObject = typeof userInfo[key] === "object"
        defaultOpt[key] = userInfo[key] || (isObject ? {} : "")
      })
      commit("setDefaultOpt", defaultOpt)
    }
  }
}
